import styled, { css } from "styled-components";

export const CommunityTopicListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  padding: 32px 32px 0;

  .room-header {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    margin-top: 32px;
    margin-bottom: 32px;

    .ant-dropdown-trigger {
      display: none !important;
    }
  }

  @media (max-width: 1050px) {
    .room-header {
      flex-direction: column;
      margin-bottom: 0;
    }
  }

  @media (max-width: 600px) {
    padding: 0;

    .go-back-btn {
      margin: 1rem 0 0 1rem;
    }
  }
`;

export const TopicsHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${({ theme }) =>
    theme.mode === "dark"
      ? css`
          background-color: #303030;
        `
      : css`
          background-color: #ffffff;
        `}

  border-radius: 8px;
  padding: 32px;
  width: 70%;
  margin-right: 32px;

  .ant-pagination {
    margin-bottom: 32px;

    span {
      ${({ theme }) =>
        theme.mode === "dark"
          ? css`
              color: #ffffff;
            `
          : css`
              color: ${({ theme }) => theme.colors?.primary};
            `}
    }

    .ant-pagination-item-link {
      ${({ theme }) =>
        theme.mode === "dark"
          ? css`
              background-color: ${({ theme }) => theme.colors?.primary};
            `
          : css`
              background-color: #ffffff;
            `}

      border: none;
    }

    .ant-pagination-item {
      transition: all 0.4s;
      border-radius: 100%;
      min-width: auto;
      width: 24px;
      height: 24px;

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        font-size: 14px;
      }
    }

    .ant-pagination-item-active {
      background: ${({ theme }) => theme.colors.primary};

      border-radius: 100%;
      border: none;

      a {
        color: #fff;
      }
    }
  }

  @media (max-width: 1366px) {
    padding: 24px;

    .ant-pagination {
      margin-bottom: 24px;

      .ant-pagination-item {
        width: 20px;
        height: 20px;
      }

      a {
        font-size: 10px !important;
      }
    }
  }

  @media (max-width: 1050px) {
    margin-bottom: 24px;
    width: 100%;
  }

  @media (max-width: 720px) {
    padding: 16px;
  }
`;
